<template>
<div class="">
    <v-row>
        <v-col cols="12" md="8" offset-md="2">
            <v-form v-model="valid" ref="user_form">
                <v-alert outlined type="info" text class="pa-2">
                    <template v-slot:prepend>
                        <v-icon size="24" color="blue" class="mr-2">info</v-icon>
                    </template>
                    <span>
                        In acest pas, va rugam sa introduceti informatiile reale, referitoare la utilizatorul care va folosi aceasta platforma.
                        Pentru a trece in pasul urmator, completati toate campurile si apasati butonul "Urmatorul pas"
                    </span>
                </v-alert>
                <v-row no-gutters>
                    <v-col md="6" cos="12" class="px-2">
                        <v-text-field label="Prenume" v-model="user.first_name" :rules="rules.name" required></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12" class="px-2">
                        <v-text-field label="Nume" v-model="user.last_name" :rules="rules.name" required></v-text-field>
                    </v-col>
                </v-row>
                <v-text-field class="px-2" label="Email" v-model="user.email" :rules="rules.email" autocomplete="off" :error="error_email" :error-messages="error_email?'E-mail taken':''" required @input="emailChanged"></v-text-field>
                <v-row no-gutters>
                    <v-col md="6" cos="12" class="px-2">
                        <v-text-field label="Parola" v-model="user.password" autocomplete="off" :append-icon="show_pass ? 'visibility' : 'visibility_off'" :type="show_pass ? 'text' : 'password'" :rules="rules.min" required @click:append="show_pass = !show_pass"></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12" class="px-2">
                        <v-text-field label="Confirmare parola" v-model="user.password_confirmation" autocomplete="off" :append-icon="show_conf ? 'visibility' : 'visibility_off'" :type="show_conf ? 'text' : 'password'" :rules="rules.match" required
                            @click:append="show_conf = !show_conf"></v-text-field>
                    </v-col>
                </v-row>

                <vue-recaptcha ref="recaptcha_register" @verify="onCaptchaVerified" @expired="onCaptchaExpired" size="invisible" :sitekey="sitekey" :loadRecaptchaScript="true" />

                <v-row no-gutters>
                    <v-col md="6" cols="12" class="px-2">
                        <div class="d-flex  align-center">
                            <v-checkbox v-model="user.gdpr" class="small py-0" label="Politica de confidentialitate" :rules="rules.gdpr" />
                            <v-btn small icon class="mx-0 my-1 pa-0" @click="privacy_dialog=true">
                                <v-icon color="rgba(0,0,0,0.5)">info</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col md="6" cols="12" class="px-2">
                        <div class="d-flex  align-center">
                            <v-checkbox v-model="user.terms" class="small py-0" label="Termeni si conditii." :rules="rules.terms" />
                            <v-btn small icon class="mx-0 my-1 pa-0" @click="terms_dialog=true">
                                <v-icon color="rgba(0,0,0,0.5)">info</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
        <v-col cols="12">
            <div class="px-2 py-3 d-flex justify-space-between">
                <v-btn color="primary" outlined :small="$vuetify.breakpoint.smAndDown" @click="prevStep()">
                    <v-icon size="16" color="primary">arrow_back_ios</v-icon>
                    <span v-if="$vuetify.breakpoint.smAndUp">Pasul anterior</span>
                    <span v-else>Inapoi</span>
                </v-btn>
                <div class="">
                    <v-tooltip bottom :disabled="valid">
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn color="primary" :small="$vuetify.breakpoint.smAndDown" :disabled="!valid" @click="handleRegister()">
                                    <span v-if="$vuetify.breakpoint.smAndUp">Urmatorul pas</span>
                                    <span v-else>Inainte</span>
                                    <v-icon size="16">arrow_forward_ios</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <span>Toate campurile sunt obligatorii</span>
                    </v-tooltip>
                </div>
            </div>
        </v-col>
    </v-row>

    <v-dialog v-model="privacy_dialog" scrollable max-width="1024">
        <v-card>
            <v-card-title class="headline" primary-title>
                Politica de confidentialitate
                <v-spacer />
                <v-btn icon @click="privacy_dialog=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="" v-html="content_privacy" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="privacy_dialog=false">Inchide</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="terms_dialog" scrollable max-width="1024">
        <v-card>
            <v-card-title class="headline" primary-title>
                Termeni si conditii
                <v-spacer />
                <v-btn icon @click="terms_dialog=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="" v-html="content_terms">
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="terms_dialog=false">
                    Inchide
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
    name: 'UserRegistration',

    components: {
        'vue-recaptcha': VueRecaptcha
    },

    props: {
        user: {
            type: Object,
        },
        error_email: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            valid: null,
            //dialogs
            privacy_dialog: false,
            terms_dialog: false,
            show_pass: false,
            show_conf: false,
            content_terms: null,
            content_privacy: null,
            // captcha sitekey
            sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
        }
    },

    created() {
        this.getTermsAndConditions();
        this.getPrivacyPolciy();
    },

    computed: {
        rules() {
            return {
                name: [v => !!v || "User first name is required"],
                email: [
                    v => !!v || "E-mail is required",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
                ],
                min: [v => /(?=.{8,})/.test(v) || 'Min 8 characters'],
                match: [
                    v => !!v || "Password confirmation is required",
                    v => this.user.password === this.user.password_confirmation || "Password must match"
                ],
                gdpr: [
                    (v) => !!v || 'You must agree with our privacy policy.',
                ],
                terms: [
                    (v) => !!v || 'You must agree with our terms & conditions.',
                ]
            }
        },
    },

    methods: {
        getTermsAndConditions() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/translations/pages?app_slug=juvo-console&fields[]=slug&search=terms-and-conditions";


            this.$axios.get(endpoint)
                .then(response => {
                    this.content_terms = response.data.data[0].translations.body.ro;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        getPrivacyPolciy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/translations/pages?app_slug=juvo-console&fields[]=slug&search=privacy-policy";


            this.$axios.get(endpoint)
                .then(response => {
                    this.content_privacy = response.data.data[0].translations.body.ro
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        nextStep() {
            this.$emit('next');
        },
        prevStep() {
            this.$emit('prev');
        },
        emailChanged() {
            this.$emit('refreshEmail')
        },
        handleRegister() {
            this.$refs.recaptcha_register.execute();
        },

        onCaptchaVerified(recaptcha) {
            this.user["g-recaptcha-response"] = recaptcha;
            this.$refs.recaptcha_register.reset();
            this.nextStep();
        },

        onCaptchaExpired() {
            this.$refs.recaptcha_register.reset();
        }
    },
}
</script>
